<template>
    <v-dialog v-model="dialog" :max-width="options.width" @keydown.esc="cancel">
        <v-toolbar   dark :color="options.color" dense v-if="title">
            <v-toolbar-title>{{ title }}</v-toolbar-title>
        </v-toolbar>
        <v-card tile>
            <v-card-text v-show="!!message">{{ message }}</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="m-1"  :color="options.color"  @click="agree">{{ options.yesLabel }}</v-btn>
                <v-btn class="m-1"  @click="cancel">{{ options.noLabel }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            message:{type:String,default:"از حذف این رکورد مطمئن هستید؟"},
            title:{type:String,default:"توجه"},
            params: Object
        },

        data() {
            return {
                dialog: false,
                options: {
                    color: 'secondary',
                    width: 320,
                    yesLabel: 'بله',
                    noLabel: 'خیر'
                }
            }
        },
        methods: {
            agree() {
                this.dialog = false
                this.$emit('close', true)
            },

            cancel() {
                this.dialog = false
                this.$emit('close', false)
            },

            open() {
                this.dialog = true
            }
        },
        created() {
            Object.assign(this.options, this.params)
        }
    }
</script>
